import * as actionTypes from './actionTypes'

export const CMSContentRequested = () => ({
  type: actionTypes.CMS_DATA_REQUESTED,
})
